module.exports = __webpack_public_path__ + "static/media/catalouge-27.3de09dd7.jpg";